import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../../../shared/environment.service';

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  constructor(public http: HttpClient, public env:EnvironmentService) { }
  baseUrl =
  `${this.env.apiUrl}/staffs`;
  
  fetchAllStaff(params:any){
    let urlParams = '';
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        if (urlParams === '') {
          urlParams += `?${key}=${params[key]}`;
        } else {
          urlParams += `&${key}=${params[key]}`;
        }
      }
    }
    let url = `staffs${urlParams}`;
    return this.env.get(url,params);
  }

  fetchAllPlanReportStaff(params:any){
    let urlParams = '';
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        if (urlParams === '') {
          urlParams += `?${key}=${params[key]}`;
        } else {
          urlParams += `&${key}=${params[key]}`;
        }
      }
    }
    let url = `staffs/all-list${urlParams}`;
    return this.env.get(url,params);
  }

  fetchSingleStaffById(staffId: any){
    let url = `v1/staffs/${staffId}`;
    return this.env.get(url);
  }

  saveStaff(params: any) {
    let url = 'v1/staffs';
    return this.env.postFormData(url, params);
  }

  updateStaff(editDataId: any, params: any) {
    let url = `v1/staffs/${editDataId}`;
    return this.env.putFormData(url, params);
  }

  updateStaffStatus(editDataId: any, params: any) {
    let url = `staffs/${editDataId}`;
   return this.env.patch(url, params);
  }

  fetchLinkedPoolDepts(staffId:any){
    let url = `staffs/department/${staffId}`;
    return this.env.get(url);
  }

  updateLinkedDeptStatus(params:any){
    let url = `staffs/department`;
    return this.env.patch(url, params);
  }

  notifyStaffPreplan(params: any) {
    let url = `wished-planning/notify-user-for-preplanning`;
    return this.env.post(url, params);
  }

  deleteStaffImage(staffId:any){
    let url = `staffs/image/remove?staffId=${staffId}`;
   return this.env.patch(url);
  }

  getAllLeavesOfStaff(_staffId:string) {
    let url = `leaves?staffId=${_staffId}`;
    return this.env.get(url);
  }

  getAllLeavesOfStaffFilter(_staffId: string, params: any) {
    let url = `leaves?staffId=${_staffId}`;
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== null &&
        params[key] !== ''
      ) {
        url += `&${key}=${encodeURIComponent(params[key])}`;
      }
    }
    return this.env.get(url);
  }

  deleteStaff(staffId:any){
   let url = `staffs/${staffId}`;
   return this.env.delete(url);
  }
  
  getTimesheet(_staffId:string, params:any ) {
    let urlParams = '';
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        if (urlParams === '') {
          urlParams += `?${key}=${params[key]}`;
        } else {
          urlParams += `&${key}=${params[key]}`;
        }
      }
    }
    let url = `timesheet/${_staffId}${urlParams}`;
    return this.env.get(url, params);
  }

  getAttendanceOverview(params: any) {
    const urlParams = this.buildUrlParams(params);
    const url = `staffs/attendance/overview${urlParams}`;
    return this.env.get(url, params);
  }

  getDutyByTimeWithAttendanceManager(params: any) {
    const urlParams = this.buildUrlParams(params);
    const url = `planning/duty-by-time-with-attendance-manager${urlParams}`;
    return this.env.get(url, params);
  }

  upsertStaffAttendanceInterval(params: any) {
    const url = `staffs/attendance/manager/interval`;
    return this.env.post(url, params);
  }

  deleteStaffAttendanceInterval(params: any) {
    const url = `staffs/attendance/manager/interval`;
    return this.env.deleteWithPayload(url, params);
  }

  private buildUrlParams(params: any): string {
    if (!params || typeof params !== 'object') {
      return '';
    }

    const queryParts: string[] = [];
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value === undefined || value === null || value === '') {
        return;
      }

      if (Array.isArray(value)) {
        value
          .filter((item) => item !== undefined && item !== null && item !== '')
          .forEach((item) => queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`));
        return;
      }

      queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    });

    return queryParts.length ? `?${queryParts.join('&')}` : '';
  }
  sendOnboardingInvite(staffId: string, webUrl: string, qrFile: File): Observable<any> {
    const url = `staffs/onboarding?staffId=${staffId}&webUrl=${encodeURIComponent(
      webUrl
    )}`;
    const formData = new FormData();
    formData.append('qrCode', qrFile);

    return this.env.postFormData(url, formData);
  }

  updateLeaveData(leaveId: string, formData: FormData): Observable<any> {
    let url = `leaves/${leaveId}`;
    return this.env.patchFormData(url, formData);
  }
}
